import { FunctionComponent, memo, ReactElement } from 'react'
import { ReactComponent as LiveSessionIcon } from './svgs/live-session.svg'
import { ReactComponent as RecordedSessionIcon } from './svgs/recorded-session.svg'
import { ReactComponent as HyphenIcon } from './svgs/hyphen.svg'
import { ReactComponent as ProfileIcon } from './svgs/profile.svg'
import { ReactComponent as ChatIcon } from './svgs/chat.svg'
import { ReactComponent as ForumIcon } from './svgs/forum.svg'
import { ReactComponent as LogoutIcon } from './svgs/logout.svg'
import { ReactComponent as LoginIcon } from './svgs/login.svg'
import { ReactComponent as MessageIcon } from './svgs/message.svg'
import { ReactComponent as LinkedinIcon } from './svgs/linkedin.svg'
import { ReactComponent as EditIcon } from './svgs/edit.svg'
import { ReactComponent as AttendanceIcon } from './svgs/attendance.svg'
import { ReactComponent as CertificateIcon } from './svgs/certificate.svg'
import { ReactComponent as RecordingIcon } from './svgs/recording.svg'
import { ReactComponent as AttendanceBoxIcon } from './svgs/attendanceBox.svg'
import { ReactComponent as PresenterSlides } from './svgs/pdf.svg'
import { ReactComponent as ProceduralGuideline } from './svgs/proceduralguide.svg'
import { ReactComponent as SampleImages } from './svgs/sampleimages.svg'
import { ReactComponent as DownloadIcon } from './svgs/download.svg'
import { ReactComponent as UploadIcon } from './svgs/upload.svg'
import { ReactComponent as MobileIcon } from './svgs/mobile.svg'
import { ReactComponent as InstagramIcon } from './svgs/instagram.svg'
import { ReactComponent as ClinicWebsite } from './svgs/clinic.svg'
import { ReactComponent as Attachment } from './svgs/attachment.svg'
import { ReactComponent as Certificate } from './svgs/certificateIcon.svg'
import { ReactComponent as OpenChevron } from './svgs/open.svg'
import { ReactComponent as ChatUsers } from './svgs/users.svg'
import { ReactComponent as CloseUsers } from './svgs/close.svg'
import { ReactComponent as Muted } from './svgs/muted.svg'
import { ReactComponent as Unmuted } from './svgs/unmuted.svg'
import { ReactComponent as Panel } from './svgs/panel.svg'
import { ReactComponent as Masterclass } from './svgs/masterclass.svg'
import { ReactComponent as Keynote } from './svgs/keynote.svg'
import { ReactComponent as Add } from './svgs/add.svg'
import { ReactComponent as Lock } from './svgs/lock.svg'

export enum SvgType {
  LIVESESSION,
  RECORDEDSESSION,
  HYPHENICON,
  PROFILE,
  CHAT,
  FORUM,
  LOGOUT,
  LOGIN,
  MESSAGE,
  LINKEDIN,
  EDITPROFILE,
  ATTENDANCE,
  CERTIFICATE,
  RECORDING,
  ATTENDANCEBOX,
  PRESENTERSLIDES,
  PROCEDURALGUIDELINE,
  SAMPLEIMAGES,
  DOWNLOAD,
  UPLOAD,
  MOBILEBURGER,
  INSTAGRAMICON,
  CLINICICON,
  ATTACHMENT,
  CERTIFICATEICON,
  OPENCHEVRON,
  CHATUSERS,
  CLOSEUSERS,
  MUTED,
  UNMUTED,
  PANEL,
  MASTERCLASS,
  KEYNOTE,
  ADD,
  LOCK
}

export interface SvgIconProps {
  type: SvgType
  className?: string
  [key: string]: any
}

export const SvgIcon: FunctionComponent<SvgIconProps> = memo(
  ({ type, className, ...svgProps }): ReactElement<void> => {
    const renderIcon = () => {
      switch (type) {
        case SvgType.LIVESESSION:
          return <LiveSessionIcon className={className} {...svgProps} />
        case SvgType.RECORDEDSESSION:
          return <RecordedSessionIcon className={className} {...svgProps} />
        case SvgType.HYPHENICON:
          return <HyphenIcon className={className} {...svgProps} />
        case SvgType.PROFILE:
          return <ProfileIcon className={className} {...svgProps} />
        case SvgType.CHAT:
          return <ChatIcon className={className} {...svgProps} />
        case SvgType.FORUM:
          return <ForumIcon className={className} {...svgProps} />
        case SvgType.LOGOUT:
          return <LogoutIcon className={className} {...svgProps} />
        case SvgType.LOGIN:
          return <LoginIcon className={className} {...svgProps} />
        case SvgType.MESSAGE:
          return <MessageIcon className={className} {...svgProps} />
        case SvgType.LINKEDIN:
          return <LinkedinIcon className={className} {...svgProps} />
        case SvgType.EDITPROFILE:
          return <EditIcon className={className} {...svgProps} />
        case SvgType.ATTENDANCE:
          return <AttendanceIcon className={className} {...svgProps} />
        case SvgType.CERTIFICATE:
          return <CertificateIcon className={className} {...svgProps} />
        case SvgType.RECORDING:
          return <RecordingIcon className={className} {...svgProps} />
        case SvgType.ATTENDANCEBOX:
          return <AttendanceBoxIcon className={className} {...svgProps} />
        case SvgType.PRESENTERSLIDES:
          return <PresenterSlides className={className} {...svgProps} />
        case SvgType.PROCEDURALGUIDELINE:
          return <ProceduralGuideline className={className} {...svgProps} />
        case SvgType.SAMPLEIMAGES:
          return <SampleImages className={className} {...svgProps} />
        case SvgType.DOWNLOAD:
          return <DownloadIcon className={className} {...svgProps} />
        case SvgType.UPLOAD:
          return <UploadIcon className={className} {...svgProps} />
        case SvgType.MOBILEBURGER:
          return <MobileIcon className={className} {...svgProps} />
        case SvgType.INSTAGRAMICON:
          return <InstagramIcon className={className} {...svgProps} />
        case SvgType.CLINICICON:
          return <ClinicWebsite className={className} {...svgProps} />
        case SvgType.ATTACHMENT:
          return <Attachment className={className} {...svgProps} />
        case SvgType.CERTIFICATEICON:
          return <Certificate className={className} {...svgProps} />
        case SvgType.OPENCHEVRON:
          return <OpenChevron className={className} {...svgProps} />
        case SvgType.CHATUSERS:
          return <ChatUsers className={className} {...svgProps} />
        case SvgType.CLOSEUSERS:
          return <CloseUsers className={className} {...svgProps} />
        case SvgType.MUTED:
          return <Muted className={className} {...svgProps} />
        case SvgType.UNMUTED:
          return <Unmuted className={className} {...svgProps} />
        case SvgType.PANEL:
          return <Panel className={className} {...svgProps} />
        case SvgType.MASTERCLASS:
          return <Masterclass className={className} {...svgProps} />
        case SvgType.KEYNOTE:
          return <Keynote className={className} {...svgProps} />
        case SvgType.ADD:
          return <Add className={className} {...svgProps} />
        case SvgType.LOCK:
          return <Lock className={className} {...svgProps} />
      }
    }
    return renderIcon()
  }
)
